import { library, type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faTwitter,
  faXTwitter,
  faYoutube,
  faInstagram,
  faFacebookF,
  faLinkedinIn,
  faPinterestP,
} from '@fortawesome/free-brands-svg-icons';
import {
  faThumbtack as faThumbtackSolid,
  faFilter as faFilterSolid,
  faStar,
  faStarHalfAlt,
  faExclamationTriangle,
  faUser as faUserSolid,
  faClock,
  faTh,
  faCloudUploadAlt,
  faArrowUp,
  faArrowDown,
  faEllipsisV,
} from '@fortawesome/free-solid-svg-icons';
import {
  faThumbtack,
  faAbacus,
  faTrashAlt,
  faBan,
  faCog,
  faComment,
  faPlayCircle,
  faBars,
  faTimes,
  faPlusCircle,
  faMinusCircle,
  faCheck,
  faUndo,
  faSignOut,
  faInbox,
  faGripHorizontal,
  faSearch,
  faPlus,
  faChevronRight,
  faChevronDown,
  faUser,
  faUsers,
  faUserMinus,
  faUserPlus,
  faSitemap,
  faArrowRight,
  faCreditCard,
  faImage,
  faFilm,
  faPhotoVideo,
  faHandshakeAlt,
  faBullseyeArrow,
  faChartLine,
  faCalendarAlt,
  faSmile,
  faPencil,
  faUserCrown,
  faHeartRate,
  faArrowToLeft,
  faArrowToRight,
  faUserShield,
  faFileContract,
  faFrown,
  faQuestionCircle,
  faInfoCircle as faInfoCircleLight,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faDownload,
  faFilter,
  faBorderAll,
  faSortAlt,
  faTerminal,
  faMagic,
  faGlobeAmericas,
} from '@fortawesome/pro-light-svg-icons';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons/faSpinnerThird';
import { faUpload } from '@fortawesome/pro-regular-svg-icons/faUpload';
import { faEye, faTv, faCode, faRss, faTrophy, faHashtag, faBrowser, faPhotoFilm } from '@fortawesome/pro-regular-svg-icons';
import { faExclamationCircle, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faDoorOpen } from '@fortawesome/pro-light-svg-icons/faDoorOpen';
import { faSkullCrossbones } from '@fortawesome/pro-light-svg-icons/faSkullCrossbones';
const faTikTok: IconDefinition = {
  prefix: 'fab',
  iconName: 'tiktok',
  icon: [
    24,
    24,
    [],
    'e001',
    'M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  ],
};

library.add(
  faImage,
  faPhotoFilm,
  faTwitter,
  faXTwitter,
  faYoutube,
  faInstagram,
  faThumbtack,
  faThumbtackSolid,
  faAbacus,
  faTrashAlt,
  faBan,
  faInbox,
  faCog,
  faComment,
  faCode,
  faEye,
  faPlayCircle,
  faBars,
  faTv,
  faTimes,
  faPlusCircle,
  faMinusCircle,
  faStar,
  faStarHalfAlt,
  faExclamationTriangle,
  faSpinnerThird,
  faCheck,
  faUndo,
  faUpload,
  faSignOut,
  faGripHorizontal,
  faSearch,
  faPlus,
  faChevronRight,
  faChevronDown,
  faUser,
  faUserSolid,
  faClock,
  faUsers,
  faUserMinus,
  faRss,
  faUserPlus,
  faSitemap,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faCreditCard,
  faTh,
  faHandshakeAlt,
  faBullseyeArrow,
  faChartLine,
  faCalendarAlt,
  faSmile,
  faPencil,
  faExclamationCircle,
  faInfoCircle,
  faInfoCircleLight,
  faHashtag,
  faUserCrown,
  faHeartRate,
  faCopy,
  faArrowToRight,
  faArrowToLeft,
  faDoorOpen,
  faTrophy,
  faSkullCrossbones,
  faCloudUploadAlt,
  faBrowser,
  faUserShield,
  faFilm,
  faPhotoVideo,
  faFileContract,
  faFacebookF,
  faLinkedinIn,
  faPinterestP,
  faTikTok,
  faFrown,
  faQuestionCircle,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faDownload,
  faFilter,
  faFilterSolid,
  faBorderAll,
  faEllipsisV,
  faSortAlt,
  faTerminal,
  faMagic,
  faGlobeAmericas,
);
